import Vue from 'vue'
import Vuex from 'vuex'
import {
  AppState, ArticleState,
  AuthState, EmployeeState, FreightServiceAddState,
  FreightServiceState, LadingCodeState, PartnerState, PickingListDeliveryState,
  PostOfficeState,
} from "@/interfaces/state";
import {RegionState} from "@/interfaces/state/region";
import {GuardState} from "@/interfaces/state/guard";
import {PickupState} from "@/interfaces/state/pickup";
import {DivisionPickupState} from "@/interfaces/state/divisionpickup";

Vue.use(Vuex);

export interface RootState {
  app: AppState;
  freightService: FreightServiceState;
  freightServiceAdd: FreightServiceAddState;
  postOffice: PostOfficeState;
  region: RegionState;
  guard: GuardState;
  auth: AuthState;
  employee: EmployeeState;
  ladingCode: LadingCodeState;
  pickup: PickupState;
  pickingListDelivery: PickingListDeliveryState;
  partner: PartnerState;
  divisionPickup: DivisionPickupState;
  article: ArticleState;
}

export default new Vuex.Store<RootState>({})
